import { render } from "./PlanList.vue?vue&type=template&id=3a0cd912&scoped=true"
import script from "./PlanList.vue?vue&type=script&lang=js"
export * from "./PlanList.vue?vue&type=script&lang=js"

import "./PlanList.vue?vue&type=style&index=0&id=3a0cd912&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0cd912"]])

export default __exports__